import type { RegistryEntry } from '../types';

// DaVinci Resolve (LUT)：UI 由 Tool 节点处理，这里只负责 modelUi -> providerOptions 透传
// NOTE: generalModelConfigs['davinci'] 在根级读取 providerOptions（非命名空间）。
export const davinciConfigs: Record<string, RegistryEntry> = {
  davinci: {
    options: [],
    toProviderOptions: (ui) =>
      ({
        lut: typeof ui.lut === 'string' ? ui.lut : undefined,
        intensity: typeof ui.intensity === 'number' ? ui.intensity : undefined,
        source_image_url: typeof ui.source_image_url === 'string' ? ui.source_image_url : undefined,
      } as unknown as Record<string, Record<string, any>>),
  },
};
